module.exports = __webpack_public_path__ + "static/graph-year-4_fr-daf9c68be98984c55021f0427cfd1933.svg";